import React from 'react';
import PropTypes from 'prop-types';
import { isFunction, isObject } from 'lib';
import { UiIcon } from 'ui-components';
import { StyledSwipeableDrawer } from './UiDrawer.styles';

export function UiDrawer(props) {
  const { window, children, open, onToggle, header, ...otherProps } = props;

  const toggleDrawer = (newOpen) => () => {
    if (isFunction(onToggle)) onToggle(newOpen);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <StyledSwipeableDrawer
      container={container}
      anchor='bottom'
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      disableSwipeToOpen={false}
      ModalProps={{
        keepMounted: true,
      }}
      {...otherProps}
    >
      {isObject(header) && (
        <>
          <div className='ui-drawer-header'>
            <div className='ui-drawer-title'>
              {header.icon}
              <span>{header.title}</span>
            </div>
            <UiIcon
              icon='ri-close-circle-fill'
              onClick={toggleDrawer(false)}
              size={24}
            />
          </div>
        </>
      )}
      {children}
    </StyledSwipeableDrawer>
  );
}

UiDrawer.propTypes = {
  window: PropTypes.func,
  children: PropTypes.node,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  header: PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.string,
  }),
  otherProps: PropTypes.object,
};
